<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter />

    <div class="container">
      <div class="col-md-3 px-3 py-4">
        <div class="form-group d-flex align-items-center">
          <label for="assetTypeId"><span class="iot-station mb-2">Report Type :</span> <span
                style="font-size: 14px;">Sensor</span></label>
        </div>
      </div>
      <div class="row px-3 mb-3">
        <div class="col-md-10"></div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="custom-label">Hub</label>
            <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
              id="autoSizingSelect" v-model="selectedHub" @change="updateControllers">
              <option value="" disabled selected>Select Option</option>
              <option v-for="hub in hubs" :key="hub.uuid" :value="hub.uuid">{{ hub.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="custom-label">Controller</label>
            <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
              id="autoSizingSelect" v-model="selectedController" @change="updateSensors">
              <option value="" disabled selected>Select Option</option>
              <option v-for="comp in components" :key="comp.uuid" :value="comp.uuid">{{ comp.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 ">
          <div class="form-group">
            <label class="custom-label">Sensor Type</label>
            <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
              id="autoSizingSelect" v-model="selectedSensorType" @change="updateSensors">
              <option value="" disabled selected>Select Option</option>
              <option v-for="sensortype in sensorTypes" :key="sensortype.uuid" :value="sensortype.uuid">{{
                sensortype.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 ">
          <div class="form-group">
            <label class="custom-label">Sensor</label>
            <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
              id="autoSizingSelect" v-model="selectedSensor">
              <option value="" disabled selected>Select Option</option>
              <option v-for="sensor in sensors" :key="sensor.uuid" :value="sensor.uuid">{{ sensor.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row px-3" :class="{ 'mb-2': !generatedSensorMessage, 'mb-1': generatedSensorMessage }">
        <div class="col-md-3">
          <div class="form-group">
            <label for="startDate" class="custom-label">Start Date</label>
            <input id="startDate" type="date" class="form-control shadow-none form-select-sm custom-input"
              v-model="selectedStartDate" @change="validateStartDates">
          </div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="form-group">
            <label for="endDate" class="custom-label">End Date</label>
            <input id="endDate" type="date" class="form-control shadow-none form-select-sm custom-input"
              v-model="selectedEndDate" @change="validateEndDates">
          </div>

        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm generate-button me-2"
              :disabled="isDateInvalid || isGenerateButtonDisabled" @click="fetchgeneratedReportData">Generate</button>
            <span v-if="startDateError" class="text-danger me-2" style="font-size: 10px;">{{ startDateError }}</span>
            <span v-if="endDateError" class="text-danger" style="font-size: 10px;">{{ endDateError }}</span>
          </div>
        </div>
        <div class="col-md-12">
          <span
            :class="{ 'text-danger': generatedSensorMessage.includes('Unable '), 'text-success': !generatedSensorMessage.includes('Unable ') }"
            style="font-size: 12px;">
            {{ generatedSensorMessage }}
          </span>
        </div>

      </div>
      <div class="row px-3 mb-4" >
        <div class="col-md-7">
          <div class="d-flex align-items-center">
            <div class="col-md-3">
              <div class="form-group">
                <label class="custom-label">Submit ID</label>
                <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
                  id="autoSizingSelect" v-model="selectedSubmitId" @change="fetchReportData">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="submitId in submitIds" :key="submitId" :value="submitId">{{ submitId.id }}</option>
                </select>
              </div>
            </div>
             <div class="form-check form-check-inline mt-4" v-if="!selectedSubmitId">

              <svg @click="fetchDDSubmitId" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#1371E7"
                class="bi bi-arrow-clockwise" style="cursor: pointer;" viewBox="0 0 16 13">
                <title>Refresh</title>
                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                <path
                  d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </div>
            <div class="form-check form-check-inline mt-4" v-if="selectedSubmitId">

              <label for="assetTypeName" class="custom-label" style="white-space: nowrap;"><strong>Filename: </strong>{{
                this.filename
              }}</label>
            </div>
            <div class="form-check form-check-inline mt-4" v-if="selectedSubmitId">

              <label for="assetTypeName" class="custom-label" style="white-space: nowrap;"><strong>Status: </strong>{{
                this.status }}</label>
            </div>
           
            <div class="form-check form-check-inline mt-4" v-if="selectedSubmitId">

              <svg @click="downloadSensorReport" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                fill="#1371E7" class="bi bi-download" style="cursor: pointer;" viewBox="0 0 16 14">
                <title>Download</title>
                <path
                  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                <path
                  d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
              </svg>
            </div>
            <div class="form-check form-check-inline mt-4" v-if="selectedSubmitId">

            <svg @click="fetchDDSubmitId" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#1371E7"
                class="bi bi-arrow-clockwise" style="cursor: pointer;" viewBox="0 0 16 13">
                <title>Refresh</title>
                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                <path
                  d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </div>


          </div>
        </div>
      </div>

      <div class="row mb-2 mt-3" v-if="selectedSubmitId">
        <div class="col-md-12">
          <div class="form-check form-check-inline me-0">
            <label for="assetTypeName" class="custom-label"><strong>Hub: </strong>{{ metadata.hub }}</label>
          </div>
          <div class="form-check form-check-inline me-0">
            <label for="assetTypeName" class="custom-label"><strong>Controller: </strong>{{
              metadata.controller }}</label>
          </div>
          <div class="form-check form-check-inline me-0">
            <label for="assetTypeName" class="custom-label"><strong>Sensor Type: </strong>{{
              metadata.sensortype }}</label>
          </div>
          <div class="form-check form-check-inline me-0">
            <label for="assetTypeName" class="custom-label"><strong>Sensor: </strong>{{ metadata.sensor }}</label>
          </div>
          <div class="form-check form-check-inline me-0">
            <label for="assetTypeName" class="custom-label"><strong>Start Date: </strong>{{ metadata.startdate
            }}</label>
          </div>
          <div class="form-check form-check-inline me-0">
            <label for="assetTypeName" class="custom-label"><strong>End Date: </strong>{{ metadata.enddate }}</label>
          </div>
        </div>
      </div>
      <div class="row px-3 py-3" v-if="selectedSubmitId">
        <div class="col-md-12">
          <table class="table table-bordered table-hover table-responsive">
            <thead class="table-light">
              <tr class="text-center">
                <th scope="col" class="align-middle">Tag Number</th>
                <th scope="col" class="align-middle">Sensor Name</th>
                <th scope="col" class="align-middle">Timestamp</th>
                <th scope="col" class="align-middle">Description </th>
                <th scope="col" class="align-middle">Consumption </th>
                <th scope="col" class="align-middle">Unit </th>
                <!-- <th scope="col" class="align-middle">Range Min</th>
                <th scope="col" class="align-middle">Range Max</th>
                <th scope="col" class="align-middle">Current Value </th> -->
              </tr>
            </thead>
            <tbody v-for="item in tableData">
              <tr class="text-center">
                <td>{{ item.sensorid }}</td>
                <td>{{ item.sensorname }}</td>
                <td>
                  <span class="mb-0">{{ item.timestamp.trim().split('.')[0].replace('T', ' ') }}</span>
                </td>
                <td>{{ item.description }}</td>
                <td>{{ item.consumption }}</td>
                <td>{{ item.unit }}</td>
                <!-- <td>{{ item.minrange}}</td>
                <td>{{ item.maxrange}}</td>
                <td>{{ item.currentvalue}}</td> -->
              </tr>
            </tbody>
          </table>

        </div>
      </div>
      <div v-if="loading" class="loading-indicator-report spinner-border spinner-border"></div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import { ddReportComponent, ddReportHub, ddReportSensor, ddReportSensorType, getReportData, ddSubmitId, DownloadSensorReportData, generateReportData } from '@/http/dashboard/report.http'; // Import the function to make API request

export default {
  name: 'reports',
  components: {
    Header,
    Filter,
  },
  data() {
    return {
      userData: JSON.parse(sessionStorage.getItem('user')),
      loading: false,
      breadcrumsfirst: "Dashboard",
      breadcrumslast: "Reports",
      tableData: [],
      submitIds: [],
      components: [],
      hubs: [],
      sensors: [],
      sensorTypes: [],
      plantNames: [
        {
          plant: "PLANT-6"
        },
      ],
      metadata: {},
      filename: '',
      status: '',
      sensorTypesFetched: false,
      selectedSubmitId: '',
      selectedStartDate: '',
      selectedEndDate: '',
      selectedHub: '',
      selectedController: '',
      selectedSensorType: '',
      selectedPlantName: { plant: "PLANT-6" },
      selectedSensor: '',
      minStartDate: '',
      maxStartDate: '',
      startDateError: '',
      minEndDate: '',
      maxEndDate: '',
      endDateError: '',
      generatedSensorMessage: ''
    }
  },
  computed: {
    isDateInvalid() {
      return this.startDateError !== '' || this.endDateError !== '';
    },
    isGenerateButtonDisabled() {
      return (
        !this.selectedHub ||
        !this.selectedController ||
        !this.selectedSensorType ||
        !this.selectedSensor ||
        !this.selectedStartDate ||
        !this.selectedEndDate
      );
    }
  },
  mounted() {
    const currentDate = new Date(); // Get current date
    const currentYear = currentDate.getFullYear(); // Get current year
    const currentMonth = currentDate.getMonth() + 1; // Get current month (Month is zero-based)
    const currentDay = currentDate.getDate(); // Get current day

    // Construct min and max dates
    this.minStartDate = `${currentYear - 1}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.maxStartDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.minEndDate = `${currentYear - 1}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.maxEndDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.fetchInitialData();
    this.fetchDDSubmitId();
  },
  methods: {
    async fetchInitialData() {
      try {
        this.hubs = await ddReportHub();
        this.hubs.unshift({ uuid: 'all', name: 'All' });
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    },
    async updateControllers() {
      try {
        if (this.selectedHub) {
          this.components = await ddReportComponent({ id: this.selectedHub });
          if (!this.components || this.components.length === 0) {
            this.selectedController = "";
          } else {
            this.components.unshift({ uuid: 'all', name: 'All' });
            this.sensorTypesFetched = false; // Reset the flag when changing hub
          }

        } else {
          this.components = [];
        }
        this.selectedController = ''; // Clear controller selection
        this.selectedSensor = ''; // Clear sensor selection
        this.selectedSensorType = '';
        this.sensors = []; // Clear sensors list
        this.sensorTypes = [];
      } catch (error) {
        console.error("Error fetching controllers:", error);
      }
    },
    async updateSensors() {
      try {
        if (this.selectedController) {
          // Call the sensor types API only if it hasn't been called yet
          if (!this.sensorTypesFetched) {
            this.sensorTypes = await ddReportSensorType();
            this.sensorTypes.unshift({ uuid: 'all', name: 'All' });
            this.sensorTypesFetched = true; // Set the flag to true after fetching
          }

          if (this.selectedSensorType) {
            this.sensors = await ddReportSensor({
              componentid: this.selectedController,
              sensorid: this.selectedSensorType
            });
            if (!this.sensors || this.sensors.length === 0) {
              this.selectedSensor = ""
            } else {
              this.sensors.unshift({ uuid: 'all', name: 'All' });
            }
          } else {
            this.sensors = [];
          }
          this.selectedSensor = ''; // Clear sensor selection
        } else {
          this.sensors = [];
        }
      } catch (error) {
        console.error("Error fetching sensors:", error);
      }
    },
    fetchgeneratedReportData() {
      this.loading = true;
      const payload = {
        startdate: this.selectedStartDate,
        enddate: this.selectedEndDate,
        hub: this.selectedHub,
        controller: this.selectedController,
        sensortype: this.selectedSensorType,
        sensor: this.selectedSensor,
        clientid: this.userData.clientid
      };


      generateReportData(payload)
        .then((response) => {
          this.generatedSensorMessage = response.message;
          setTimeout(() => {
            this.generatedSensorMessage = '';
          }, 5000);
        })
        .catch(error => {
          console.error("Error fetching report data:", error);
        })
        .finally(() => {
          this.loading = false;
        })

    },
   
    async fetchDDSubmitId() {
      try {
        this.selectedSubmitId = '';
        const response = await ddSubmitId({ username: this.userData.username });
        this.submitIds = Array.isArray(response) ? response : [response];
      } catch (error) {
        console.error("Error fetching submit ID:", error);
      }
    },
    fetchReportData() {
      if (this.selectedSubmitId) {
        this.loading = true;
        this.tableData = [];
        getReportData({ clientid: this.selectedSubmitId.id })
          .then(response => {
            this.tableData = response.report
            this.tableData.map((element) => {
              this.filename = element.filename
              this.status = element.status
            })

            this.metadata = response.metadata
          })
          .catch(error => {
            console.error('Error fetching export data:', error);
          }).finally(() => {
            this.loading = false;
          })
      }
    },
    //     downloadSensorReport() {
    //   if (!this.selectedSubmitId) {
    //     return;
    //   }

    //   this.loading = true;

    //   DownloadSensorReportData({ clientid: this.selectedSubmitId.id })
    //     .then(response => {
    //       // Extract filename from headers if available
    //       const disposition = response.headers['content-disposition'];
    //       let filename = this.filename || 'report_download';

    //       if (disposition) {
    //         const match = disposition.match(/filename="?(.+)"?/);
    //         if (match && match[1]) filename = match[1];
    //       }

    //       const blob = new Blob([response.data], { type: response.data.type });
    //       const url = window.URL.createObjectURL(blob);

    //       const a = document.createElement('a');
    //       a.href = url;
    //       a.download = filename;
    //       a.style.display = 'none';

    //       document.body.appendChild(a);
    //       a.click();

    //       // Clean up
    //       a.remove();
    //       window.URL.revokeObjectURL(url);
    //     })
    //     .catch(error => {
    //       console.error('Download failed:', error);
    //       alert('Failed to download the file. Please try again.');
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    downloadSensorReport() {
      if (!this.selectedSubmitId) return;

      this.loading = true;

      // Ensure your API call sets responseType: 'blob'
      DownloadSensorReportData({ clientid: this.selectedSubmitId.id })
        .then(blobResponse => {
          const blob = new Blob([blobResponse], { type: 'text/csv' });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `sensor_report_${this.selectedSubmitId.id.slice(2)}.csv`);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Download failed:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateStartDates() {
      if (this.selectedStartDate && this.selectedStartDate < this.minStartDate) {
        this.startDateError = 'select start date after ' + this.minStartDate;
        this.selectedStartDate = ''; // Clear the invalid date
      } else if (this.selectedStartDate && this.selectedStartDate > this.maxStartDate) {
        this.startDateError = 'select start date before ' + this.maxStartDate;
        this.selectedStartDate = ''; // Clear the invalid date
      } else {
        this.startDateError = '';
      }
    },
    validateEndDates() {
      if (this.selectedEndDate && this.selectedEndDate < this.minEndDate) {
        this.endDateError = 'select end date after ' + this.minEndDate;
        this.selectedEndDate = ''; // Clear the invalid date
      } else if (this.selectedEndDate && this.selectedEndDate > this.maxEndDate) {
        this.endDateError = 'select end date before ' + this.maxEndDate;
        this.selectedEndDate = ''; // Clear the invalid date
      } else {
        this.endDateError = '';
      }
    }
  },

}
</script>




<style scoped></style>